export enum StorageKeys {
  ALLOWED_COOKIES = 'allowed_cookies',
  SELECTED_PACKAGE = 'selected_package',
  AVAILABLE_LANGS = 'available_langs',
}
